import React, { useState } from "react";

export default function ReplaceCartPopup({ show, onConfirm, onCancel }) {
  const [loading, setLoading] = useState(false);
  if (!show) return null;

  const handleConfirm = async () => {
    try {
      setLoading(true);
      await onConfirm();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.6)", zIndex: 1050 }} />
      <div className="d-flex justify-content-center align-items-center" style={{ position: "fixed", inset: 0, zIndex: 1060 }}>
        <div className="bg-white p-5 rounded-4 shadow-lg text-center" style={{ width: "380px", maxWidth: "90%" }}>
          <h4 className="text-danger fw-bold mb-3">Replace Cart?</h4>
          <p>Your cart contains items from another lab.<br />Do you want to replace it?</p>
          <div className="d-flex justify-content-center gap-3">
            <button className="btn btn-danger fw-bold px-4" onClick={onCancel} disabled={loading}>Cancel</button>
            <button className="btn btn-success fw-bold px-4" onClick={handleConfirm} disabled={loading}>{loading ? "Replacing..." : "Yes, Replace"}</button>
          </div>
        </div>
      </div>
    </>
  );
}